import axios from 'axios';

export default axios.create({
    baseURL: process.env.REACT_APP_API_URL || `${process.env.REACT_APP_AUDIENCE}api`,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});